import { Types } from './types';
const initialState = {
    dataLoan: {
        paging: {},
        rows: [],
    },
    dataUserLoan: {
        paging: {},
        rows: [],
    },
    dataHistory: {
        paging: {},
        rows: [],
    },

}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_LOAN:
            return {
                ...newState,
                dataLoan: action.payload
            }
        case Types.SAVE_LIST_USER_LOAN:
            return {
                ...newState,
                dataUserLoan: action.payload
            }
        case Types.SAVE_HISTORY_PAYMENT:
            return {
                ...newState,
                dataHistory: action.payload
            }
        default:
            return newState
    }
}
export default reducer
